import {
    QualificationQuestionsAnswers,
    QualificationQuestionsAnswersBusiness,
    QualificationQuestionsAnswersPartner,
    TypeOfBusiness,
} from 'modules/data/domain';

import { FirstStartProfileData } from '../types';

export const prepareQualificationQuestions = (data: FirstStartProfileData): QualificationQuestionsAnswers | null => {
    if (data.typeOfBusiness === TypeOfBusiness.Partner) {
        const answers: QualificationQuestionsAnswersPartner = {
            typeOfBusiness: [data.typeOfBusiness],
            numberOfClients: data.numberOfClients ? [data.numberOfClients] : undefined,
            partnerStatus: data.partnerStatus ? [data.partnerStatus] : undefined,
            segment: data.partnerSegment ? [data.partnerSegment] : undefined,
            useCase: data.useCase || undefined,
        };

        return answers;
    }

    if (data.typeOfBusiness === TypeOfBusiness.Business) {
        const answers: QualificationQuestionsAnswersBusiness = {
            typeOfBusiness: [data.typeOfBusiness],
            numberOfEntities: data.numberOfEntities ? [data.numberOfEntities] : undefined,
            productInterest: data.productInterest ? [data.productInterest] : undefined,
            segment: data.businessSegment ? [data.businessSegment] : undefined,
            useCase: data.useCase || undefined,
        };

        return answers;
    }

    return null;
};
